export default function SurveyAxisMoveController(view, model) {
  return ({
    index,
    value
  }) => {
    if (index != 0) return;
    if (value < -0.5) view.selectPrevAnswer();else if (value > 0.5) view.selectNextAnswer();
  };
}